window.addEventListener('DOMContentLoaded', () => {

    const searchBlock = document.querySelector('.search-block');
    const searchInput = document.querySelector('.search-block input');
    const searchForm = document.querySelector('.search-block form');
    const searchError = document.querySelector('.search-wrapper > span');
    
    searchInput.addEventListener('input', (e) => {
        if(e.target.value.length >= 3){
            searchBlock.classList.add('filled');
            searchError.innerText = "";
        } else{
            searchBlock.classList.remove('filled');
            // searchError.innerText = "Ce champ doit contenir au moins 3 caractères";
        }
    })

    searchForm.addEventListener('submit', (e) => {
        if(searchInput.value.length < 3){
            e.preventDefault();
            searchError.innerText = searchError.dataset.error;
        }
    })


    const btnNext = document.querySelector('.pagination-container .next a');
    const btnPrev = document.querySelector('.pagination-container .prev a');

    // if(btnNext){
    //     btnNext.innerHTML = `<span class="next">${btnNext.innerText.split('»')[0]}</span><img class="arrow-right" src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/XMLID_29_2.svg?v=1678874435">`
    // }
    // if(btnPrev){
    //     btnPrev.innerHTML = `<img class="arrow-left" src="https://cdn.shopify.com/s/files/1/0602/6376/0064/files/XMLID_29.svg?v=1678874435"><span class="prev">${btnPrev.innerText.split('«')[1]}</span>`
    // }

})

 $(document).ready(function() {
  const pathName = window.location.href;

  // Handle page number clicks in pagination
  $(document).on('click', '.pagination-container .page a', function() {
    var pageNumber = $(this).data('page');
    var url = pathName + '&page=' + pageNumber;
    $.ajax({
      type: "GET",
      url: url,
      dataType: 'html',
      success: function(html) {
        var newData = $(html).find('.recent-articles-container').html();
        $('.search-desktop-container').html(newData);
      },
      error: function(xhr, status, error) {
        console.error('Error fetching page:', error);
      }
    });
  });

  // Handle next page click in pagination
  $(document).on('click', '.pagination-container .next:not(.grey) a', function(e) {
    e.preventDefault();
    var pageNumber = $(this).attr('href');
    var url = pageNumber;
    $.ajax({
      type: "GET",
      url: url,
      dataType: 'html',
      success: function(html) {
        var newData = $(html).find('.recent-articles-container').html();
        $('.search-desktop-container').html(newData);
      },
      error: function(xhr, status, error) {
        console.error('Error fetching next page:', error);
      }
    });
  });

  // Handle previous page click in pagination
  $(document).on('click', '.pagination-container .prev:not(.grey) a', function(e) {
    e.preventDefault();
    var pageNumber = $(this).attr('href');
    var url = pageNumber;
    $.ajax({
      type: "GET",
      url: url,
      dataType: 'html',
      success: function(html) {
        var newData = $(html).find('.recent-articles-container').html();
        $('.search-desktop-container').html(newData);
      },
      error: function(xhr, status, error) {
        console.error('Error fetching previous page:', error);
      }
    });
  });


});



window.addEventListener('DOMContentLoaded', () => {

$(window).on('load',function(){
   if($(this).width() < 850){
     var height = $('.search-mobile-slider').height();
     $('.search-mobile-slider').css('min-height', height);
   }
 }) 

 $(window).resize(function(){
   if($(this).width() < 850){
     setTimeout(function(){
       var height = $('.search-mobile-slider').height();
       $('.search-mobile-slider').css('min-height', height);
     }, 500)
   }
 }) 

  var reviFromLast = false;
  var reverseProcess = false;
  var dotsToShow = $('#dots_to_shows').val();
  dotsToShow = parseInt(dotsToShow);
  
  $(document).on('click','.next-arrow-btn',function(){
    var currentIndex = $('.slick-slide.slick-active').data('slick-index');
    currentIndex = currentIndex + 1
    $('.search-mobile-slider').slick('slickGoTo', currentIndex);
    if(currentIndex%dotsToShow == 0){
      setTimeout(function(){
       var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      },500)
    }
  })

  
  $('.search-mobile-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var slideCount = slick.slideCount;
    if(slideCount - 1 == nextSlide){
      $('.next-arrow').addClass('grey');
    }else{
      $('.next-arrow').removeClass('grey');
    }

    if(nextSlide == 0){
      $('.prev-arrow').addClass('grey');
    }else{
      $('.prev-arrow').removeClass('grey');
    }
    
  });


  $(document).on('click','.prev-arrow-btn',function(){
    var currentIndex = $('.slick-slide.slick-active').data('slick-index');
    if(reviFromLast == false && reverseProcess == false){
      currentIndex = currentIndex - 1; 
    }
    $('.search-mobile-slider').slick('slickGoTo', currentIndex);
    reviFromLast = false;
    reverseProcess = false;
    var minV = dotsToShow - 1
    if(currentIndex%dotsToShow == minV){
      var activeIndex = $('.slick-dots li.slick-active').find('button').html();
      activeIndex = parseInt(activeIndex);
      
      var nactiveIndex = parseInt(activeIndex) - dotsToShow;
      $('.slick-dots').find('li').each(function(index, el){
        if($(this).hasClass('slick-active')){
         var elindex = index;
         var minusValue = dotsToShow - 1;
         indexSum = elindex - minusValue;
         // indexSum = elindex - 3;
         $(this).show();
        }else if(nactiveIndex <= index && activeIndex > index){
          $(this).show();
        }else{
         $(this).hide();
        }
      });
    }
  })

  $('.search-mobile-slider').on('swipe', function(event, slick, direction){
    var sliderCount = slick.slideCount;
    if(direction == 'left'){
      var currentIndex = $('.slick-slide.slick-active').data('slick-index');
      if(currentIndex%dotsToShow == 0){
        var indexSum = 0;
        $('.slick-dots').find('li').each(function(index, el){
         if($(this).hasClass('slick-active')){
           var elindex = index;
           indexSum = elindex + dotsToShow;
             $(this).show();
         }else if(indexSum > index){
            $(this).show();
         }else{
           $(this).hide();
         }
        });
      }
    }else{
      var currentIndex = $('.slick-slide.slick-active').data('slick-index');
      var minV = dotsToShow - 1
      if(currentIndex%dotsToShow != 0 && sliderCount - 2 == currentIndex){
        setTimeout(function(){
          reviFromLast = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }else if(currentIndex%dotsToShow == minV){
        setTimeout(function(){
          reviFromLast = false;
          reverseProcess = true;
          $('.prev-arrow-btn').trigger('click');
        },500)
      }
    }
  }); 

  




    var slickLastDot = $('.search-mobile-container .search-mobile-slider').data('slickdot');
  initSlider();

// Initialize Slick slider with appropriate settings
function initSlider(dir = 'next') {
    var $slickContainer = $('.search-mobile-container .search-mobile-slider');
    var currentSlidesCount = $slickContainer.find('.recent-article').length;
    
    var $paginationContainer = $('.search-mobile-container .pagination-container');
    var $customPaginationContainer = $('.search-mobile-container .custom-pagination-container');
    var $nextButton = $paginationContainer.find('> .next');
    var $prevButton = $paginationContainer.find('> .prev');
   $paginationContainer.hide();
  $customPaginationContainer.show();
    if ($slickContainer.length > 0) {
        $slickContainer.slick({
            infinite: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 880,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                        centerPadding: '50px'
                    }
                }
            ]
        });

        // if(dir == 'prev') {
        //   $slickContainer.slick('slickGoTo', $slickContainer.find('div.recent-article').length);
        // }

        // Register event handlers for beforeChange and afterChange
        // $slickContainer.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        //     console.log('Before changing slide from', currentSlide, 'to', nextSlide);
        // });

        $slickContainer.on('afterChange', function(event, slick, currentSlide) {
          
          var $paginationContainer = $('.search-mobile-container .pagination-container');
          var $customPaginationContainer = $('.search-mobile-container .custom-pagination-container');
          var $nextButton = $paginationContainer.find('> .next');
          var $prevButton = $paginationContainer.find('> .prev');
          var currentPage = $('[name="current_page_1"]').val();
          var totalPages = $('[name="page_size_1"]').val();
          $customPaginationContainer.find('.prev-arrow').show();
          
          if(currentSlide == 0 && currentPage != 1){
            $paginationContainer.show();
            // $customPaginationContainer.hide();
            $nextButton.click();
            $prevButton.show();
            $prevButton.removeClass('grey');
            $customPaginationContainer.find('.prev-arrow').hide();
            // $customPaginationContainer.find('.next-arrow').show();
            // $nextButton.hide();
            
            
          }else if(currentSlide == (currentSlidesCount - 1) && currentPage != totalPages){
            $paginationContainer.show();
            $prevButton.hide();
            $nextButton.removeClass('grey');
            
            $customPaginationContainer.find('.next-arrow').hide();
            // $customPaginationContainer.hide();
          }
            // updatePaginationVisibility();
            console.log('After changing slide to', currentSlide);
        });
      
      

        // updatePaginationVisibility();
    } else {
        console.error('Slick container not found');
    }
}

// Update pagination visibility and control state based on current slide
function updatePaginationVisibility() {
    var $slickContainer = $('.search-mobile-container .search-mobile-slider');
    var slickCurrentSlide = $slickContainer.slick('slickCurrentSlide');
    var totalSlides = $slickContainer.slick('getSlick').slideCount;

    var $paginationContainer = $('.search-mobile-container .pagination-container');
    var $customPaginationContainer = $('.search-mobile-container .custom-pagination-container');
    var $nextButton = $paginationContainer.find('.next');
    var $prevButton = $paginationContainer.find('.prev');
  

    if (slickCurrentSlide === totalSlides - 1) {
        $paginationContainer.show();
        $customPaginationContainer.hide();
    } else {
        $paginationContainer.hide();
        $customPaginationContainer.show();
    }

    // Update grey class based on current slide position
    if (slickCurrentSlide === totalSlides - 1) {
        $nextButton.addClass('grey');
    } else {
        $nextButton.removeClass('grey');
    }

    if (slickCurrentSlide === 0) {
        $prevButton.addClass('grey');
    } else {
        $prevButton.removeClass('grey');
    }
}

// Load new content via AJAX and reinitialize the slider


  
function loadNewContent(url, dir) {
  var currentPage = $('[name="current_page_1"]').val();
  var totalPages = $('[name="page_size_1"]').val();
  currentPage = parseInt(currentPage);
  if(dir == 'next') {
    var nextPage = currentPage + 1;
  }else if(dir == 'prev'){
    var nextPage = currentPage - 1;
  }
  var url = window.location.href+'&page='+nextPage
    $.ajax({
        type: "GET",
        url: url,
        dataType: 'html',
        success: function(html) {
            var $slickContainer = $('.search-mobile-container .search-mobile-slider');
            var $paginationContainer = $('.search-mobile-container .pagination-container');
            var $customPaginationContainer = $('.search-mobile-container .custom-pagination-container');
            var $prevButton = $paginationContainer.find('> .prev');
            var $nextButton = $paginationContainer.find('> .next');
            if ($slickContainer.hasClass('slick-initialized')) {
                $slickContainer.slick('unslick');
            }

            var newData = $(html).find('.search-mobile-container .search-mobile-slider').html();
            $('.search-mobile-container .search-mobile-slider').html(newData);

            initSlider(dir); // Re-initialize slider after loading new content
            var totalSlides = $('.search-mobile-container .search-mobile-slider').slick('getSlick').slideCount;
            if(dir == 'prev') {
              console.log('Total SLider',totalSlides)
              $slickContainer.slick('slickGoTo', totalSlides - 1);
            }
            $paginationContainer.hide();
            $customPaginationContainer.show();
            $customPaginationContainer.find('.next-arrow').show();
            $customPaginationContainer.find('.prev-arrow').show();
            $prevButton.show();
            $nextButton.show();
            
        },
        error: function(xhr, status, error) {
            console.error('Error fetching new content:', error);
        }
    });
}

// Event handlers for pagination controls
$(document).on('click', '.pagination-container .next:not(.grey) a', function(e) {
    e.preventDefault();
  console.log("clicked");
   
    var $paginationContainer = $('.search-mobile-container .pagination-container');
    var $customPaginationContainer = $('.search-mobile-container .custom-pagination-container');
    var $nextButton = $paginationContainer.find('.next');
    var $prevButton = $paginationContainer.find('.prev');
    var currentIndex = $('.search-mobile-container .search-mobile-slider').find('.slick-current').data('slick-index');
    var totalSlides = $('.search-mobile-container .search-mobile-slider').slick('getSlick').slideCount;
   
    if (currentIndex < totalSlides - 1) {
        var newIndex = currentIndex + 1;
        $('.search-mobile-container .search-mobile-slider').slick('slickGoTo', newIndex);
      
    } else {
        var pageNumber = $(this).attr('href');
        loadNewContent(pageNumber, 'next');
      console.log("here is appen")
        $customPaginationContainer.show();
        $paginationContainer.hide();
        $customPaginationContainer.find('.next-arrow').removeClass('grey');
        $customPaginationContainer.find('.prev-arrow').addClass('grey');
    }
});

$(document).on('click', '.pagination-container .prev:not(.grey) a', function(e) {
    e.preventDefault();
  console.log("clicked");
    var currentIndex = $('.search-mobile-container .search-mobile-slider').find('.slick-current').data('slick-index');
    
    if (currentIndex > 0) {
        var newIndex = currentIndex - 1;
        $('.search-mobile-container .search-mobile-slider').slick('slickGoTo', newIndex);
    } else {
        var pageNumber = $(this).attr('href');
        loadNewContent(pageNumber, 'prev');
    }
});

// Initialize the slider on page load
$(document).ready(function() {
    initSlider();
});

});